<template>
  <section>
    <b-card title="">
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <v-select
            id="v-Province"
            v-model="filterDevice.province"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="ProvinceOptions"
            :reduce="ProvinceOptions => ProvinceOptions.value"
            label="title"
            placeholder="--Select Province --"
            class="w-100"
            @input="onProvinceChange"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <v-select
            id="v-Regency"
            v-model="filterDevice.regency"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="RegencyOptions"
            :reduce="RegencyOptions => RegencyOptions.value"
            label="title"
            placeholder="--Select Regency --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="filterDevice.installation_date"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
              placeholder="DD-MM-YYYY"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Installation Date</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="filterDevice.approved_at"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, }"
              placeholder="DD-MM-YYYY"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Approved Date</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="1"
          class="mb-md-0 mb-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="primary"
            @click="filterz()"
          >
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
        <b-col
          cols="12"
          md="1"
          class="mb-md-0 mb-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="outline-primary"
            @click="resetFilter()"
          >
            Reset
          </b-button>
        </b-col>
        <!-- <b-col
              cols="12"
              md="3"
              class="mb-md-0 mb-2"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="DistrictOptions" :reduce="DistrictOptions => DistrictOptions.value"
                v-model="select_8"
                id="v-District"
                label="title"
                placeholder="--Select District --"
                class="w-100" style="display: none;"
              />
            </b-col> -->
      </b-row>
    </b-card>
    <b-card-code
      title=""
      no-body
    >
      <b-card>
        <b-row
          xl="12"
          sm="12"
        >
          <b-col
            cols="12"
            md="2"
            style="margin-top: -40px;"
          >
            <h3>{{ stats.project_name }}</h3>
          </b-col>
          <b-col
            cols="12"
            md="8"
            style="margin-top: -32px;"
          >
            <b-progress
              animated
              :value="stats.percentage"
              variant="primary"
              class="'progress-bar-primary'"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            style="margin-top: -40px;"
          >
            <h3>{{ stats.percentage }} %</h3>
          </b-col>
        </b-row>
        <b-row
          xl="12"
          sm="12"
        >
            &nbsp;
        </b-row>
        <b-row
          xl="12"
          sm="12"
        >
          <b-col
            xl="12"
            sm="12"
          >
            <b-row>
              <b-col
                v-for="item in data"
                :key="item.icon"
                xl="4"
                sm="6"
                :class="item.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="item.color"
                    >
                      <b-img :src="item.icons" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body
                    class="my-auto"
                    style="text-align: center;"
                  >
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.subtitle }}
                    </h4>
                    <b-card-text class="xmb-0">
                      <template v-if="item.subtitle === 'Total Terpasang'">
                        <h4>{{ stats.installed_total }}</h4>
                      </template>
                      <template v-else-if="item.subtitle === 'Terpasang Hari Ini'">
                        <h4>{{ stats.installed_today }}</h4>
                      </template>
                      <template v-else-if="item.subtitle === 'Belum Terpasang'">
                        <h4>{{ stats.installed_waiting }}</h4>
                      </template>
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-card-code>
    <b-card-code
      title="Data"
      no-body
    >
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-card>
          <b-row>
            <b-col
              cols="12"
              md="4"
              class="mb-md-0 mb-2"
              style="display: none;"
            >
              <v-select
                id="v-Province"
                v-model="select_6"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="ProvinceOptions"
                :reduce="(ProvinceOptions) => ProvinceOptions.value"
                label="title"
                placeholder="--Select Province --"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mb-md-0 mb-2"
              style="display: none;"
            >
              <v-select
                id="v-Regency"
                v-model="select_7"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="RegencyOptions"
                :reduce="(RegencyOptions) => RegencyOptions.value"
                label="title"
                placeholder="--Select Regency --"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mb-md-0 mb-2"
              style="display: none;"
            >
              <v-select
                v-model="select_site"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="SiteOptions"
                :reduce="(SiteOptions) => SiteOptions.value"
                label="title"
                placeholder="Site"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="mb-md-0 mb-2"
            >
&nbsp;
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="mb-md-0 mb-2"
              style="display: none;"
            >
              <v-select
                v-model="select_device_type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="DeviceTypeOptions"
                :reduce="(DeviceTypeOptions) => DeviceTypeOptions.value"
                label="title"
                placeholder="Device Type"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-md-0 mb-2"
            >
              <v-select
                v-model="select_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="StatusOptions"
                :reduce="(StatusOptions) => StatusOptions.value"
                label="title"
                placeholder="Installation Status"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-md-0 mb-2"
            >
              <v-select
                v-model="filterDevice.device_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="StatusDeviceOptions"
                :reduce="(StatusDeviceOptions) => StatusDeviceOptions.value"
                label="title"
                placeholder="Device Status"
                class="w-100"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-md-0 mb-2"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="sidebar-center"
                variant="outline-primary"
                @click="filterz()"
              >
                <feather-icon icon="SearchIcon" /> Filter
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="ml-1"
                variant="outline-primary"
                @click="exportExcel"
              >
                <feather-icon icon="DownloadIcon" /> Export
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="2"
              style="display: none;"
            >
              <div>
                <!-- Add -->
                <b-link :to="{ path: '/temperature-device/installation' }">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    class="ml-1 mb-1"
                    variant="outline-primary"
                  >
                    <feather-icon icon="PlusIcon" /> Installation
                  </b-button>
                </b-link>
              </div>
            </b-col>
          </b-row>
          <div><div class="h-50 d-inline-block" /></div>
          <div class="d-flex justify-content-between flex-wrap">
            <!-- sorting  -->
            <b-form-group
              label="Sort"
              label-size="sm"
              label-align-sm="left"
              label-cols-sm="3"
              label-for="sortBySelect"
              class="ml-1"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sortBySelect"
                  v-model="sortBy"
                  :options="sortOptions"
                >
                  <template #first>
                    <option value="">
                      none
                    </option>
                  </template>
                </b-form-select>
                <b-form-select
                  v-model="sortDesc"
                  size="sm"
                  :disabled="!sortBy"
                >
                  <option :value="false">
                    Asc
                  </option>
                  <option :value="true">
                    Desc
                  </option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>
            <!-- filter -->
            <b-form-group
              label="Filter"
              label-cols-sm="2"
              label-align-sm="left"
              label-size="sm"
              label-for="filterInput"
              class="mr-1"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <b-table
            striped
            hover
            responsive
            class="position-relative"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            @page-changed="currentPage = $event"
            @per-page-changed="perPage = $event; currentPage = 1; filterz()"
          >
            <template #cell(installation_date)="data">
              {{ data.value ? dateFormat(data.value) : '-' }}
            </template>
            <template #cell(approved_at)="data">
              {{ data.value ? dateFormat(data.value) : '-' }}
            </template>
            <template #cell(installation_note)="data">
              {{ data.value || '-' }}
            </template>
            <template #cell(code)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.id }"
              >
                <span>{{ row.item.code }}</span>
              </b-link>
            </template>
            <template #cell(serial_number)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.id }"
              >
                <span>{{ row.item.serial_number }}</span>
              </b-link>
            </template>
            <template #cell(value)="row">
              {{ `${row.item.value !== null ? Number(row.item.value).toFixed(2) : "0.00"}` }}
            </template>
            <template #cell(value_power)="row">
              {{ `${row.item.value_power !== null ? Number(row.item.value_power).toFixed(2) : "0.00"}` }}
            </template>
            <template #cell(installation_status)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(device_status_connection)="data">
              <b-badge :variant="device_status[1][data.value]">
                {{ device_status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(action)="row">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <!-- <template v-if="row.item.installation_status === 'IN'">
                    <b-dropdown-item>
                      <b-link :to="{ path: '/temperature-installation/edit/'+ row.item.installation_id}">
                      <feather-icon icon="Edit2Icon" class="mr-50" />
                      <span>Edit</span>
                      </b-link>
                    </b-dropdown-item>
                  </template> -->
                  <b-dropdown-item>
                    <b-link :to="{ path: '/temperature-installation/detail/' + row.item.id }">
                      <feather-icon
                        icon="AirplayIcon"
                        class="mr-50"
                      />
                      <span>Detail</span>
                    </b-link>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </template>
          </b-table>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <p class="text-nowrap mb-md-0 mr-1 align-left" />
            <!-- page length -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                style="align-content: right"
                @input="filterz"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-card-code>
  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCol,
  BOverlay,
  BProgress,
  BCard,
  BRow,
  BTable,
  BImg,
  BBadge,
  BMediaBody,
  BAvatar,
  BCardText,
  BMediaAside,
  BMedia,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store/index'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(x => `.${x}`).join(',')

export default {
  components: {
    BCardCode,
    XLSX,
    vSelect,
    BCol,
    BOverlay,
    BProgress,
    BCard,
    BRow,
    BTable,
    BImg,
    BBadge,
    BMediaBody,
    BAvatar,
    BCardText,
    BMediaAside,
    BMedia,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BDropdown,
    BDropdownItem,
    ToastificationContent,
    flatPickr,
  },
  data() {
    return {
      data: [
        {
          icons: require('@/assets/images/icons/site.png'),
          icon: 'UsersIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Total Terpasang',
          customClass: 'mb-4 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/online.png'),
          icon: 'UserIcon',
          color: 'light-info',
          title: 0,
          subtitle: 'Terpasang Hari Ini',
          customClass: 'mb-4 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: 'DollarSignIcon',
          color: 'light-success',
          subtitle: 'Belum Terpasang',
          title: 0,
          customClass: 'mb-4 mb-sm-0',
        },
      ],
      dir: false,
      show: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterDevice: {
        regency: null,
        province: null,
        installation_date: null,
        approved_at: null,
        device_status: null,
      },
      stats: [],
      filterOn: [],
      select_6: '',
      select_7: '',
      select_8: '',
      select_9: '',
      select_site: '',
      select_device_type: '',
      select_status: undefined,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Approve', value: 'IN' },
        { title: 'Approve With Note', value: 'DF' },
        { title: 'Waiting Verif', value: 'VF' },
        { title: 'Reject', value: 'RJ' },
        { title: 'Complete', value: 'CP' },
      ],
      StatusDeviceOptions: [
        { title: 'Online', value: 'ONLINE' },
        { title: 'Offline', value: 'OFFLINE' },
      ],
      status: [
        {
          IN: 'Approve',
          DF: 'Approve With Note',
          VF: 'Waiting Verif',
          RJ: 'Reject',
          CP: 'Complete',
        },
        {
          IN: 'light-warning',
          DF: 'light-success',
          VF: 'light-info',
          RJ: 'light-danger',
          CP: 'light-success',
        },
      ],
      device_status: [
        {
          ONLINE: 'Online',
          OFFLINE: 'Offline',
        },
        {
          ONLINE: 'light-success',
          OFFLINE: 'light-warning',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      SiteOptions: state => state.site.options,
      LocationOptions: state => state.location.options,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
      totalRows: state => state.temperature.deviceListInstallation.totalRows,
      totalActive: state => state.temperature.deviceListInstallation.totalActive,
      totalOffline: state => state.temperature.deviceListInstallation.totalOffline,
      totalError: state => state.temperature.deviceListInstallation.totalError,
      fields: state => state.temperature.deviceListInstallation.fields,
      items: state => state.temperature.deviceListInstallation.items,
      pageOptions: state => state.temperature.deviceListInstallation.pageOptions,
      perPageOptions: state => state.temperature.deviceListInstallation.perPage,
    }),
    mapFilter() {
      return {
        status: this.select_status,
        province_id: this.filterDevice.province,
        regency_id: this.filterDevice.regency,
        installation_date: this.filterDevice.installation_date,
        approved_at: this.filterDevice.approved_at,
        device_status: this.filterDevice.device_status,
        page: this.currentPage,
        limit: this.perPage,
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    // totalExpenses() {
    //   return this.items.reduce((accum, item) => {
    //     // Assuming expenses is the field you want to total up
    //     return accum + parseFloat(item.expenses);
    //   }, 0.0);
    // },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
  },
  watch: {
    select_6(obj) {
      this.$store.dispatch('site/setFilterProvince', obj)
      return this.$store.dispatch('region/regency', obj)
    },
    select_7(obj) {
      this.$store.dispatch('site/setFilterRegency', obj)
      return this.$store.dispatch('region/district', obj)
    },
  },
  created() {
    this.show = true
    this.$store.dispatch('temperature/getDeviceType')
    this.$store.dispatch('region/province')
    // this.$store.dispatch("site/setFilterRegency", "")
    // this.$store.dispatch("location/getAll")
    this.setData()
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    onProvinceChange(selectedProvince) {
      this.$store.dispatch('region/regency', selectedProvince)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update when filtered
      this.totalRows = filteredItems.length
      this.currentPage = 1
      this.filterz()
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('device/remove', id).then(
              response => {
                if (response.status === 200) {
                  this.$store.dispatch('temperature/getDeviceListInstallation', this.params)
                  this.notification(
                    'Success',
                    'CheckIcon',
                    'success',
                    'You have successfully',
                  )
                } else {
                  this.notification(
                    'Failed',
                    'CloseIcon',
                    'danger',
                    'You have unsuccessful',
                  )
                }
              },
              error => {
                this.notification(
                  'Failed',
                  'CloseIcon',
                  'danger',
                  'You have unsuccessful',
                )
              },
            )
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    resetFilter() {
      this.filterDevice = {
        regency: null,
        province: null,
        installation_date: null,
        approved_at: null,
        device_status: null,
      }
      this.filterz()
    },
    filterz() {
      this.show = true
      this.params = this.mapFilter
      this.$store.dispatch('temperature/getDeviceListInstallation', this.params)
      this.show = false
      console.log(this.items)
    },
    setData() {
      this.params = this.mapFilter
      this.$store.dispatch('temperature/getDeviceListInstallation', this.params).then(resp => {
        this.stats = resp.data.stats
      })
      this.show = false
    },
    //     Device Code
    // Serial Number
    // Value
    // Power
    // Signal Strength
    // Installation Date
    // Site Name
    // Province
    // Regency

    // tambahin di excel
    // - photo bast 1
    // - photo bast 2
    // - photo documentation 1
    // - photo documentation 2
    // - photo documentation 3
    // - photo documentation 4
    // - photo documentation 5
    // - photo documentation 6
    // - photo documentation 7
    // - photo documentation 8
    exportExcel(evt) {
      const jsons = []
      for (let x = 0; x < this.items.length; x++) {
        jsons[x] = {
          No: this.items[x].no,
          'Device Code': this.items[x].code,
          'Serial Number': this.items[x].serial_number,
          Value: `${this.items[x].value} ${this.items[x].default_unit}`,
          Power: this.items[x].value_power ?? 0,
          'Signal Strength': this.items[x].signal_strength ?? 0,
          'Installator Name': this.items[x].installator_name,
          'Installation Date': this.dateFormat(this.items[x].installation_date),
          'Installation Note': this.items[x].installation_note,
          'Approved Date': this.items[x].approved_at ? this.dateFormat(this.items[x].approved_at) : '-',
          Status: this.status[0][this.items[x].installation_status] ?? '-',
          'Device Status': this.status[0][this.items[x].device_status] ?? '-',
          'Site Name': this.items[x].locations?.areas?.sites?.name ?? '-',
          Province: this.items[x].locations?.areas?.sites?.region_provinces?.name ?? '-',
          Regency: this.items[x].locations?.areas?.sites?.region_regencies?.name ?? '-',
          'File Documentation': this.items[x].file_documentation ?? '-',
          'File Calibration': this.items[x].file_calibration ?? '-',
          'File BAST': this.items[x].file_bast ?? '-',
          'Photo Bast 1': this.items[x].photo_bast_1 ?? '-',
          'Photo Bast 2': this.items[x].photo_bast_2 ?? '-',
          'FOTO SMILE': this.items[x].photo_smile ?? '-',
          'FOTO PLANG FASILITAS KESEHATAN': this.items[x].photo_documentation_1 ?? '-',
          'FOTO RUANG TEMPAT INSTALASI': this.items[x].photo_documentation_2 ?? '-',
          'FOTO TEMPAT PENYIMPANAN VAKSIN': this.items[x].photo_documentation_3 ?? '-',
          'FOTO DUS DEVICE': this.items[x].photo_documentation_4 ?? '-',
          'FOTO LETAK PENYIMPANAN GLYCOL': this.items[x].photo_documentation_5 ?? '-',
          'FOTO DEVICE TERPASANG': this.items[x].photo_documentation_6 ?? '-',
          'FOTO SERAH TERIMA DUS DEVICE': this.items[x].photo_documentation_7,
          'FOTO ANTENA EXTERNAL /   SIGNAL DEVICE': this.items[x].photo_documentation_8,
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
      XLSX.writeFile(wb, `${this.stats.project_name}-Installation-${new Date().toLocaleString('en-GB', {
        timeZone: 'Asia/Jakarta',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).split('/').join('-')}.xlsx`)
    },
  },
  directives: {
    Ripple,
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
